export interface Instance {
    element: HTMLElement;
}

export interface Disposable {
    dispose(): void;
}
export interface ValueComponent extends Disposable {
    name: string;
    value: any;
}

export interface Validation extends Instance, Disposable {
    isValid(): boolean;
}

export interface FormElement {
    row: HTMLElement,
    controls: ValueComponent[],
    validation: Validation
}

export interface Validator {
    isNotValid(value: any): boolean;
    message: string;
    name: string;
}
export abstract class ValueElement extends EventTarget implements
            ValueComponent, Instance {
    private elementName: string;

    constructor(name: string) {
        super();
        this.elementName = name;
    }

    abstract get value(): any;
    abstract set value(val: any);

    get name(): string {
        return this.elementName;
    }

    abstract get element(): HTMLElement;

    protected onChange(): void {
        this.dispatchEvent(new Event("valueChanged"));
    }

    abstract disable(): void;

    abstract dispose(): void;
}
